import {
  BackgroundImageTag,
  ContentTag,
  isInPlaceEditingActive,
  provideComponent
} from "scrivito"

import { FinalCallToActionWidget } from "./FinalCallToActionWidgetClass"
import "./styles/_final-call-to-action-widget.scss"

provideComponent(FinalCallToActionWidget, ({ widget }) => {
  const actionButton =
    isInPlaceEditingActive() || widget.get("button") ? (
      <ContentTag
        className="final-call-to-action-widget__action-button"
        tag="div"
        content={widget}
        attribute="button"
      />
    ) : null

  return (
    <div className="final-call-to-action-widget">
      <BackgroundImageTag
        style={{ background: { image: widget.get("lightImage") } }}
        className="final-call-to-action-widget__bg final-call-to-action-widget__bg--light"
      />
      <BackgroundImageTag
        style={{ background: { image: widget.get("darkImage") } }}
        className="final-call-to-action-widget__bg final-call-to-action-widget__bg--dark"
      />

      <div className="final-call-to-action-widget__text">
        <ContentTag
          tag="h2"
          className="final-call-to-action-widget__title"
          content={widget}
          attribute="title"
        />
        <ContentTag
          className="final-call-to-action-widget__subtitle"
          tag="div"
          content={widget}
          attribute="subtitle"
        />
      </div>

      {actionButton}
    </div>
  )
})
